import { baseGeospatial } from "../../../api/base/baseUrl";

const BASE_URL = "/api/v1/pricing-holiday";

export async function getPricingHolidayListRequest() {
  const response = await baseGeospatial.get(`${BASE_URL}/get-all-list`);
  return response.data;
}

export async function getPricingHolidayByIdRequest(id) {
  const response = await baseGeospatial.get(`${BASE_URL}/get-by-id/${id}`);
  return response.data;
}

export async function createPricingHolidayRequest(payload) {
  const response = await baseGeospatial.post(BASE_URL, payload);
  return response.data;
}

export async function updatePricingHolidayRequest(payload) {
  const response = await baseGeospatial.put(`${BASE_URL}/update`, payload);
  return response.data;
}

export async function deletePricingHolidayRequest(id) {
  const response = await baseGeospatial.delete(`${BASE_URL}/delete/${id}`);
  return response.data;
}
